export const apiHost = "https://api.zhouyuanpei.tk/blog/"
export const imgPrefix = "https://api.zhouyuanpei.tk/cover/"
